// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QxpU","colBig":"styles_colBig__1iu_i","colSmall":"styles_colSmall__wGsPU","shopifyNameWrapper":"styles_shopifyNameWrapper__3bqrR"};